import { Box, Spinner } from '@factorialco/deprecated-design-system'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'

import { usePayrollContextlessPolicies } from 'modules/payroll_bundle/hooks/usePayrollContextlessPolicies'
import IncidencesPage from 'modules/payroll_bundle/pages/IncidencesPage'

const GuardedIncidencesPage = () => {
  const { loading, canManagePayrollIncidences } = usePayrollContextlessPolicies()

  if (loading) {
    return (
      <Box gap="s8" padding="s48" alignItems="center" data-testid="guarded-incidences-page-loading">
        <Spinner size="s40" />
      </Box>
    )
  }

  return (
    <AuthorizeUser authorizeFn={() => canManagePayrollIncidences}>
      <IncidencesPage />
    </AuthorizeUser>
  )
}

export default GuardedIncidencesPage
